export class DocumentModel {

    constructor(
        private year: object = { isEditable: false, type: 'number', value: undefined },
        private month: object = { isEditable: false, type: 'number', value: undefined },
        private day: object = { isEditable: false, type: 'number', value: undefined },
        private country: object = { isEditable: true, type: 'string', value: undefined },
        private state: object = { isEditable: true, type: 'string', value: undefined },
        private city: object = { isEditable: true, type: 'string', value: undefined },
        private names: object = { isEditable: true, type: 'array', value: undefined },
        private keywords: object = { isEditable: true, type: 'array', value: undefined },
        private occasion: object = { isEditable: true, type: 'string', value: undefined },
        private venue: object = { isEditable: true, type: 'string', value: undefined },
        private en: object = { isEditable: true, type: 'string', value: undefined },
        private da: object = { isEditable: true, type: 'string', value: undefined },
    ){}

    verifyKey( key?: any ): boolean {
      return Object.keys( this ).find( ( thisKey: string) => thisKey === key ) ? true : false ;
    }

    isEditable( key?: any): any {
      const candidate = this.verifyKey( key ) && ( typeof this[key] === 'object' && !Array.isArray( this[key] ));
      if ( this[key] && candidate ) {
        const { isEditable } = this[key];
        return { isEditable: isEditable }
      } else {
        return;
      }
    }

    get( key?: string ): any {
      const exists = this.verifyKey( key );
      if ( exists ) {
        return this[key];
      } else {
        return;
      }
    }

    set( keyValuePairs?: object ) {
      Object.keys(keyValuePairs).forEach((key: string) => {
        if ( this.verifyKey( key ) ) {
          const thisValue = keyValuePairs[key];
          Array.isArray(this[key]) ? this[key].push( thisValue ) : this[key] = thisValue;
        }
      });
    }

    reset( key?: string ): void {
      const keys = Object.keys( this );
      keys.forEach(( element: string ) => {
        if ( this.isEditable( element ) ) {
          const { isEditable } = this.isEditable( element );
          this[element] = key === element ? true : undefined;
        }
      });
      return;
    }

    clear(): void {
      Object.keys(this).forEach( (key: any) => {
        if ( this.isEditable( key ) ) {
          this[key].value = [];
        }
      });
    }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/models/document.model.ts